import { OptionsClass } from "./MainApp";
import { PaginationV2 } from "./Pagination";

export class SummarySTTData {
  sttNo = "";
  lastStatus = "";
  updatedAt = "";
  bookingDate = "";
  posName = "";
  posLevel = "";
  origin = "";
  destination = "";
  productType = "";
  estimationDate = "";
  isOnSLA = false;
  isCOD = false;
  isDFOD = false;
  rejectReason = "";
  dexAttemps = 0;
  delAttemps = 0;
  codRejAttemps = 0;
  courierName = "";
  lastDelivPartnerName = "";
  lastDelivAt = "";

  constructor(fields?: Partial<SummarySTTData>) {
    Object.assign(this, fields);
  }
}

export const PusatResolusiV2CodeResponseCreate = {
  101: 101,
  102: 102,
  103: 103,
  104: 104
};

export const PusatResolusiV2Status = {
  NEW: {
    label: "Baru",
    text: "text-blue-lp-300",
    background: "bg-blue-lp-200"
  },
  WORKING: {
    label: "Dalam proses",
    text: "text-yellow-lp-100",
    background: "bg-yellow-lp-400"
  },
  ESCALATED: {
    label: "Dalam eskalasi",
    text: "text-purple-lp-800",
    background: "bg-purple-lp-100"
  },
  "ON HOLD": {
    label: "Ditunda sementara",
    text: "text-gray-lp-300",
    background: "bg-gray-lp-200"
  },
  SOLVED: {
    label: "Selesai",
    text: "text-green-lp-400",
    background: "bg-green-lp-300"
  },
  CLOSED: {
    label: "Ditutup",
    text: "text-chocolate-lp-100",
    background: "bg-chocolate-lp-200"
  },
  DEFAULT: {
    label: "-",
    text: "text-gray-lp-300",
    background: "bg-gray-lp-200"
  }
};

export enum PusatResolusiV2Action {
  VIEW_DETAIL = "VIEW_DETAIL",
  CLAIM = "CLAIM",
  CS = "CS"
}

export const PusatResolusiV2Type = {
  shippingService: "PENGIRIMAN_BANTUAN",
  systemPenalty: "SISTEM_BANDING_PINALTI"
};

export class PusatResolusiV2Detail {
  type = PusatResolusiV2Type.shippingService;
  sttNoShipmentNo = "";
  category = new OptionsClass();
  description = "";
  attachments: (File | null)[] = [null];
  isDescRequired = true;
  isAttachmentRequired = true;

  constructor(fields?: Partial<PusatResolusiV2Detail>) {
    Object.assign(this, fields);
  }
}

export class TicketPusatResolusiDetail {
  id = 0;
  caseNumber = "";
  ticketNo = "";
  refNo = "";
  categoryCode = "";
  categoryName = "";
  ticketSource = "";
  desc = "";
  isEligibleCategory = false;
  shipmentId = "";
  shipmentLastStatus = "";
  sttNo = "";
  sttLastStatus = "";
  message = "";
  status = "";
  success = false;
  code = 200;
  action: PusatResolusiV2Action | "" = "";

  constructor(fields?: Partial<TicketPusatResolusiDetail>) {
    Object.assign(this, fields);
  }

  get statusData() {
    return PusatResolusiV2Status[
      this.status?.toUpperCase() as keyof typeof PusatResolusiV2Status
    ] || {...PusatResolusiV2Status['DEFAULT'], label: this.status};
  }
}

export class CategoryPusatResolusi {
  code = "";
  type = "";
  typeLabel = "";
  label = "";
  template = "";
  isEligible = false;
  isDescRequired = true;
  isAttachmentRequired = true;

  constructor(fields?: Partial<CategoryPusatResolusi>) {
    Object.assign(this, fields);
  }
}

export class TicketCounterPusatResolusi {
  countTicketNeedToBeSolved = 0;
  countNewMessage = 0;
  countMention = 0;

  constructor(fields?: Partial<TicketCounterPusatResolusi>) {
    Object.assign(this, fields);
  }
}

export class PusatResolusiSTTData {
  data: PusatResolusiSTT[];
  page: number;
  limit: number;
  totalRecords: number;
  isLoading: boolean;

  constructor(fields: Partial<PusatResolusiSTTData> = {}) {
    const { data = [], page = 1, limit = 20, totalRecords = 0 } = fields;
    this.data = data;
    this.page = page;
    this.limit = limit;
    this.totalRecords = totalRecords;
    this.isLoading = false;
  }
}

export class PusatResolusiSTT {
  sttNo = "";
  senderName = "";
  originCity = "";
  destinationCity = "";
  lastStatus = "";
  constructor(fields?: Partial<PusatResolusiSTT>) {
    Object.assign(this, fields);
  }
}

export class ListTicketData {
  id = 0;
  issueNo = "";
  needToBeSolved = false;
  sttOrShipmentNumber = "";
  categoryIssue = "";
  ticketPriority = "";
  statusTicket = "";
  createdAt = "";
  createdBy = "";
  unreadMessage = false;
  mentioned = false;
  eligibleAction = "";
  assignToUsername = "";

  constructor(fields?: Partial<ListTicketData>) {
    Object.assign(this, fields);
  }

  get statusData() {
    return PusatResolusiV2Status[
      this.statusTicket?.toUpperCase() as keyof typeof PusatResolusiV2Status
    ] || {...PusatResolusiV2Status['DEFAULT'], label: this.statusTicket};
  }
}

export class ListTicketPusatResolusi {
  pagination = new PaginationV2();
  data: ListTicketData[] = [];

  constructor(fields?: Partial<ListTicketPusatResolusi>) {
    Object.assign(this, fields);
  }
}
export class CheckIssuePusatResolusi {
  id = 0;
  caseNumber = "";
  refNo = "";
  categoryCode = "";
  categoryName = "";
  isEligibleCategory = false;
  shipmentLastStatus = "";
  sttLastStatus = "";
  statusTicket = "";
  action = "";

  constructor(fields?: Partial<CheckIssuePusatResolusi>) {
    Object.assign(this, fields);
  }
}

export class MentionsData {
  type = "";
  code = "";
  name = "";
  constructor(fields?: Partial<MentionsData>) {
    Object.assign(this, fields);
  }
}
export class CategoryData {
  code = "";
  case = "";
  type = "";
  typeLabel = "";
  label = "";

  constructor(fields?: Partial<CategoryData>) {
    Object.assign(this, fields);
  }
}

export class AttachmentData {
  name = "";
  size = 0;
  fileName = "";
  ext = "";
  url = "";
  sizeInKB = 0;

  constructor(fields?: Partial<AttachmentData>) {
    Object.assign(this, fields);
  }
}

export class RequestFinishForumPusatResolusi {
  message = "";
  mentions: MentionsData[] = [];
  attachments: any = [];
  constructor(fields?: Partial<RequestFinishForumPusatResolusi>) {
    Object.assign(this, fields);
  }
}
export class EscalatePartnerData {
  escalateAt = "";
  escalateFinish = "";
  escalatePartnerCode = "";
  escalatePartnerName = "";
  escalatePartnerUsername = "";
  createdAt = "";
  isYou = false;

  constructor(fields?: Partial<EscalatePartnerData>) {
    Object.assign(this, fields);
  }
}

export class FollowerData {
  accountPartnerCode = "";
  accountPartnerName = "";
  accountUsername = "";
  isYou = false;

  constructor(fields?: Partial<FollowerData>) {
    Object.assign(this, fields);
  }
}

export class TicketData {
  id = 0;
  refNo = "";
  ticketNo = "";
  desc = "";
  status = "";
  caseNumber = 0;
  categoryCode = "";
  category = new CategoryData();
  priority = "";
  attachments: AttachmentData[] = [];
  createdAt = "";
  createdBy = 0;
  createdByUsername = "";
  createdByPartnerCode = "";
  createdByPartnerName = "";
  createdByTier = "";
  updatedAt = "";
  note = "";
  agentCsName = "";
  agentCsId = "";
  agentCsAt = "";
  agentCsFullname = "";
  escalatePartner: EscalatePartnerData[] = [];
  escalatePartnerHistory: EscalatePartnerData[] = [];
  followers: FollowerData[] = [];

  constructor(fields?: Partial<TicketData>) {
    Object.assign(this, fields);
  }
}

export class SummaryData {
  isSla = false;
  bookedAt = "";
  bookedName = "";
  bookedTier = "";
  lastStatus = "";
  lastStatusAt = "";
  originCity = "";
  destinationCity = "";
  product = "";
  estimatedSlaStartDate = "";
  estimatedSlaEndDate = "";
  isCod = false;
  isDfod = false;
  isInsurance = false;
  grossWeight = 0;
  volumeWeight = 0;
  chargeableWeight = 0;
  totalPiece = 0;
  dimLength = 0;
  dimHeight = 0;
  dimWidth = 0;
  codAmount = 0;
  goodsPrice = 0;
  totalDelAttempt = 0;
  totalDexAttempt = 0;
  totalCodrejattempt = 0;
  lastDelivStatus = "";
  lastDelivAt = "";
  lastDelivReasonCode = "";
  lastDelivReasonName = "";
  lastDelivPartnerCode = "";
  lastDelivPartnerName = "";
  lastDelivCourierName = "";
  commodityCode = "";
  commodityName = "";
  commodityIsDg = false;
  commodityIsQuarantine = false;

  constructor(fields?: Partial<SummaryData>) {
    Object.assign(this, fields);
  }
}

export class TicketDetail {
  ticket = new TicketData();
  summary = new SummaryData();

  constructor(fields?: Partial<TicketDetail>) {
    Object.assign(this, fields);
  }
}

export class TicketAction {
  isOpenMultipleTab = false;
  isAssignedToOther = false;
  assignedUsername = "";
  action: string[] = [];

  constructor(fields?: Partial<TicketAction>) {
    Object.assign(this, fields);
  }
}

export class ConversationValueAttachment {
  name = "";
  url = "";
  sizeInMegabytes = 0;
  ext = "";

  constructor(fields?: Partial<ConversationValueAttachment>) {
    Object.assign(this, fields);
  }
}

export class ConversationValueMention {
  type = "";
  code = "";
  name = "";

  constructor(fields?: Partial<ConversationValueMention>) {
    Object.assign(this, fields);
  }
}

export class ConversationValue {
  oldAgent = "";
  newAgent = "";
  oldPriority = "";
  newPriority = "";
  status = "";
  oldCategory = "";
  newCategory = "";
  note = "";
  isSolved = false;
  message = "";
  title = "";
  escalatePartnerCode = "";
  escalatePartnerName = "";
  escalateNoteConversationId = 0;
  mentions: ConversationValueMention[] = [];
  attachments: ConversationValueAttachment[] = [];

  constructor(fields?: Partial<ConversationValue>) {
    Object.assign(this, fields);
  }
}

export class Conversation {
  id = 0;
  type = "";
  createdBy = 0;
  createdName = "";
  createdByPartnerCode = "";
  createdByPartnerName = "";
  createdAt = "";
  groupDate = "";
  time = "";
  isMentioned = false;
  assignedTo = "";
  isAssignedToOther = false;
  isOpenMultipleTab = false;
  isEscalatePartner = false;
  assignedUsername = "";
  error = "";
  action: string[] = [];
  value: ConversationValue = new ConversationValue();

  constructor(fields?: Partial<Conversation>) {
    Object.assign(this, fields);
  }
}

export class HistoryChatData {
  lastReadId = 0;
  lastReadAt = "";
  firstUnreadMessageAt = "";
  unreadCount = 0;
  conversations: Conversation[] = [];

  constructor(fields?: Partial<HistoryChatData>) {
    Object.assign(this, fields);
  }
}

export class HistoryChatResponse {
  data: HistoryChatData = new HistoryChatData();
  beforeId = 0;
  limit = 20;
  totalRecords = 0;

  constructor(fields?: Partial<HistoryChatResponse>) {
    Object.assign(this, fields);
  }
}
